import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SwitchButton extends PureComponent {
  render() {
    const { text, isSelected, onSwitchButtonClicked } = this.props;

    const switchButtonClassName = classnames(styles.SwitchButton,
        { [styles._selected]: isSelected });
    const textClassName = classnames(styles.SwitchButton_content_text,
        { [styles._selected]: isSelected });
    const circleClassName = classnames(styles.SwitchButton_content_circle,
        { [styles._selected]: isSelected });

    return <div className={switchButtonClassName} onClick={onSwitchButtonClicked}>
      <div className={styles.SwitchButton_content}>
        <span className={textClassName}>{text}</span>
        <div className={circleClassName} />
      </div>
    </div>;
  }
}

SwitchButton.propTypes = {
  text: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  onSwitchButtonClicked: PropTypes.func.isRequired,
};

export default SwitchButton;



// WEBPACK FOOTER //
// ./components/SwitchButton/index.jsx